import styled from "styled-components";

interface ExportButtonProps {
  variant: "primary" | "secondary";
  width?: number;
}

const ExportExcelContainer = styled.div<ExportButtonProps>`
  background-color: ${({ theme, variant }) =>
    variant === "primary" ? theme.colors.primary.main : theme.colors.white};
  padding: 0.4rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  border-radius: 0.5rem;
  color: ${({ theme, variant }) =>
    variant === "primary" ? theme.colors.white : theme.colors.primary.main};
  cursor: pointer;
  font-weight: bold;
  width: ${({ width }) => width ?? 120}px;
  ${({ variant, theme }) =>
    variant === "secondary" &&
    `border: 1px solid ${theme.colors.primary.main}`};

  &:hover {
    color: ${({ theme, variant }) =>
      variant === "primary"
        ? theme.colors.neutral.neutral10
        : theme.colors.primary.hover};
    ${({ variant, theme }) =>
      variant === "secondary" &&
      `border: 1px solid ${theme.colors.primary.hover}`};
    transition: all ease-in-out 0.25s;
  }
`;

export { ExportExcelContainer };
